import {useParams, useRouteMatch} from 'react-router-dom';
import {UserCardsAssociations} from '../../../../../../../components/user-cards-associations/user-cards-associations';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../i18n/translations';

export default function SeniorUserCardsProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id?: string; entityId?: string} = useParams();
  const officeContext = useOffice();
  const {t} = useTranslation();
  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;
  const {hasWritePermission} = useAuth();
  const canWriteCards = hasWritePermission(RolePermissionType.Seniors_DigitalInclusion_Cards);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <UserCardsAssociations
      caregiverMode={CaregiverMode.Professional}
      canWrite={canWriteCards}
      entityId={entityId || ''}
      userId={id || ''}
      userName={userName || ''}
      associateCardUrl={url.charAt(url.length - 1) === '/' ? `${url}associate` : `${url}/associate`}
      cardRowBaseLinkUrl={url}
      headerTitleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: userName || '',
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.role_permissions_section['digital-inclusion']),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_DigitalInclusion}`,
        },
        {
          label: t(translations.screen_paths.senior_user_cards),
          link: url,
        },
      ]}
    />
  );
}
